<script setup lang="ts">
	import * as z from 'zod'
	import type { FormSubmitEvent } from '@nuxt/ui'

	const rConf = useRuntimeConfig()

	const schema = z.object({
		email: z.string().nonempty('Sie müssen ihre Email-Adresse angeben').email('Bitte eine gültige Email-Adresse angeben')
	})

	type Schema = z.output<typeof schema>

	const state = reactive<Partial<Schema>>({
		email: undefined,
	})

	const loading = ref(false)
	const showError = ref<boolean>(false)
	const showSuccess = ref<boolean>(false)

	async function onSubmit(event: FormSubmitEvent<Schema>) {
		loading.value = true
		try {
			const body: any = { data: JSON.parse(JSON.stringify(event.data)), honey: true, hook_id: '01KN2HMEFE75QH4HC0BYT97M61' }
			await $fetch('/rest/cms/mailing', { method: 'POST', body, baseURL: rConf.public.apiBase })
			showSuccess.value = true
			setTimeout(() => showSuccess.value = false, 6000)
		} catch (e: any) {
		 	showError.value = true
		 	setTimeout(() => showError.value = false, 6000)
		} finally {
			loading.value = false
			state.email = undefined
		}
	}
</script>

<template>
	<div class="text-white text-center">
		<span class="font-chillax-semibold block text-[1.375rem] sm:text-[1.5rem] md:text-[1.75rem] lg:text-[1.875rem] xl:text-[2rem] 2xl:text-[2.125rem] leading-10 mb-2.5">Newsletter abonnieren</span>
		<p class="text-[1.125rem] text-white/50">Bleiben Sie informiert über Neuigkeiten, Projekte und Veranstaltungen</p>
	</div>
	<Transition
		enter-active-class="transition-all duration-300"
		enter-from-class="opacity-0 scale-90"
		enter-to-class="opacity-100 scale-100"
		leave-active-class="transition-all duration-300"
		leave-from-class="opacity-100 scale-100"
		leave-to-class="opacity-0 scale-90"
	>
		<div v-if="showSuccess" class="bg-accent rounded-lg p-4 mb-10">
			<span class="text-white text-center block">
				Vielen Dank für Ihre Anmeldung in unserer Newsletter-Liste.
			</span>
		</div>
	</Transition>
	<Transition
		enter-active-class="transition-all duration-300"
		enter-from-class="opacity-0 scale-90"
		enter-to-class="opacity-100 scale-100"
		leave-active-class="transition-all duration-300"
		leave-from-class="opacity-100 scale-100"
		leave-to-class="opacity-0 scale-90"
	>
		<div v-if="showError" class="bg-red-600 text-white rounded-lg p-4 mb-10">
			<span class="text-white text-center block">Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie uns.</span>
		</div>
	</Transition>
	<UForm :schema="schema" :state="state" class="flex flex-col xs:flex-row mx-auto gap-6 mt-2.5 mb-12" @submit="onSubmit">

		<UFormField name="email" aria-label="Ihre E-Mail Adresse">
			<UInput v-model="state.email" placeholder="Ihre E-Mail Adresse" required color="neutral" variant="ghost" />
		</UFormField>

		<div class="flex">
			<GsBtn type="submit" title="im Newsletter-Verteiler anmelden" label="Anmelden" color="accent" variant="solid" class="mb-auto py-2 w-full"></GsBtn>
		</div>
	</UForm>
</template>

<style>
	.text-error {
		font-size: 14px;
	}
</style>
